

export const useImgLightboxStyles = ({ isOpen, container, img }) => {
  if (!img.current) return {};

  if (!isOpen) {
    return {
      scale: 1,
      translateX: 0,
      translateY: 0,
      transform: 'scale(1) translate(0px, 0px)',
    };
  }

  const { clientWidth, clientHeight, naturalWidth, naturalHeight } = img.current;

  // Depending on alignment of the image ("margin: 0 auto" or "margin-left: auto"), the image will scale outside
  // of the parent element. The calculated margin-left of the image will give us how much we need to move the button
  // to download to the right.
  /* eslint-disable-next-line no-undef */
  const style = getComputedStyle(img.current);
  const marginLeft = style.getPropertyValue('margin-left');

  const { x, y } = img.current.getBoundingClientRect();
  const { innerWidth, innerHeight } = container;

  const maxHeight = Math.min(innerHeight * 0.8, naturalHeight);
  const verticalScale = maxHeight / clientHeight;
  const widthConstrainedByMaxHeight = clientWidth * verticalScale;

  // Smallest value between 80% of window width, width constrained by max height, or original width of image.
  const maxWidth = Math.min(widthConstrainedByMaxHeight, innerWidth * 0.8, naturalWidth);

  const scale = maxWidth / clientWidth;

  // Get mid point translated image.
  const transitionMidPointX = (innerWidth - maxWidth) / 2;
  const translateX = transitionMidPointX - x;

  // Vertical transition depends on if max height is scaling the image.
  const offsetHeight = maxWidth === widthConstrainedByMaxHeight ? maxHeight : clientHeight * scale;
  const transitionMidPointY = (innerHeight - offsetHeight) / 2;
  const translateY = transitionMidPointY - y;

  return {
    imageWidth: scale > 1 ? clientWidth : '100%',
    buttonTranslateX: marginLeft,
    scale,
    translateX,
    translateY,
    transform: `scale(${scale > 1 ? scale : 1}) translate(${translateX}px, ${translateY}px)`,
    ... scale > 1 ?
      { height: clientHeight * scale, width: clientWidth * scale } :
      { height: Math.min(clientHeight * scale, maxHeight), width: clientWidth * scale },
    aspectRatio: `${clientWidth} / ${clientHeight}`,
  };
};
